// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
   apiKey: "AIzaSyBtPnvp1GpsRf6mjChLsqtQ4NW6c8gjKBU",
  authDomain: "thebox-project.firebaseapp.com",
  projectId: "thebox-project",
  storageBucket: "thebox-project.firebasestorage.app",
  messagingSenderId: "204786346641",
  appId: "1:204786346641:web:6e578c8f283af9e7e2ed30",
  measurementId: "G-0XZZPSTBGN"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
